var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-app',[(!_vm.$store.getters.getLang)?_c('language-page'):_c('v-main',[_c('header-bar'),_c('menu-mobile',{staticClass:"d-lg-none"}),_c('router-view'),_c('footer-view')],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }